import { isObject, deepCopy, toString, getFormId } from '../../utils/tools';
import { RadioPersonProps } from './types';

export interface DataLabelValue {
  [propName: string]: any;
}

/**
 * 获取单选项值
 * @param value
 */
export function getRadioValue(value: any) {
  if (value && isObject(value)) {
    value = value.value;
  }

  return value;
}

/**
 * 获取选择值
 * @param props
 */
export function getSelectedValues(props: RadioPersonProps) {
  if (props && (props.value || props.defaultValue)) {
    const initialValue = props.value || props.defaultValue;

    if (initialValue && isObject(initialValue) && initialValue.list) {
      return initialValue.list;
    }
  }

  return [];
}

/**
 * 获取选项label
 * @param values
 * @param childs
 */
export function getItemLabel(values: DataLabelValue, childs: any[]) {
  if (!(values && isObject(values))) {
    return {};
  }

  const labels = deepCopy(values);
  let filter: any[] = [];

  if (childs && Array.isArray(childs) && childs.length) {
    childs.forEach((item) => {
      if (
        item
        && item.wprops
        && item.wprops.options
        && Array.isArray(item.wprops.options)
        && item.wprops.options.length
      ) {
        filter = item.wprops.options.filter((oItem: any) => oItem && toString(oItem.value) === toString(labels[item.dataBind || item.name]));

        if (filter && Array.isArray(filter) && filter.length) {
          labels[item.dataBind || item.name] = filter[0].label;
        }
      }
    });
  }

  return labels;
}

/**
 * 获取form name
 * @param props
 */
export function getNames(props: RadioPersonProps) {
  const { _crengine } = props;
  const { form, path, dataBind, childrens } = _crengine || {};

  if (form && dataBind) {
    let names = getFormId(dataBind, path);

    // 渲染引擎存在子级，path 会添加dataBind
    if (childrens && Array.isArray(childrens) && childrens.length) {
      names = path;
    }

    return names;
  }

  return '';
}
